var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Slider } from '@material-ui/core';
export const ConfirmSlider = (_a) => {
    var { classes, confirmed = false, onChange = () => { } } = _a, rest = __rest(_a, ["classes", "confirmed", "onChange"]);
    return (React.createElement(Slider, Object.assign({ disabled: confirmed, classes: classes, onChange: onChange }, rest)));
};
//# sourceMappingURL=ConfirmSlider.js.map